<template>

    <div class="user-menu">
        <b-navbar-brand>
            <main-logo/>
        </b-navbar-brand>
        <back-nav/>
        <b-navbar toggleable="lg" type="light">

            <b-badge class="main-menu__environment"
                     v-if="$store.state.environment !== 'production'">
                Environment: {{ $store.state.environment }}
            </b-badge>

            <b-navbar-toggle target="nav-collapse"/>

            <b-collapse id="nav-collapse" class="main-menu-wrapper" is-nav>
                <b-navbar-nav class="main-menu">
                    <div v-if="isApproved" class="main-menu__center menu-group">
                        <b-nav-item to="/equipment/list">
                            Equipment
                        </b-nav-item>
                        <template v-if="$user.isEquipmentOwner()">
                            <b-nav-item to="/rental-equipment/list">
                                Rental Equipment
                            </b-nav-item>
                        </template>
                        <b-nav-item to="/project/list">
                            Projects
                        </b-nav-item>
                        <b-nav-item v-if="$user.isAdmin() || $user.isSuperAdmin()" to="/company/list">
                            Companies
                        </b-nav-item>
                        <template v-if="$user.isAdmin() || $user.isSuperAdmin() || $user.isProgramAdmin()">
                            <b-nav-item to="/registration/list">
                                Registrations
                            </b-nav-item>
                        </template>
                        <b-nav-item-dropdown text="More">
                            <template v-if="$user.isAdmin() || $user.isSuperAdmin()">
                                <b-dropdown-item to="/agency/list">Agencies</b-dropdown-item>
                                <!-- <b-dropdown-item to="/registration/list">Registrations</b-dropdown-item>-->
                                <b-dropdown-item to="/rental/list">Project Rentals</b-dropdown-item>
                                <b-dropdown-item to="/rentalcompany/list">Global Rentals</b-dropdown-item>
                                <b-dropdown-item to="/rental-equipment/list">Rental Equipment</b-dropdown-item>
                            </template>
                            <template v-if="$user.isAdmin() || $user.isSuperAdmin() || $user.isProgramAdmin()">
                                <b-dropdown-item to="/exemption/list">Exemptions</b-dropdown-item>
                            </template>
                            <template v-if="!$user.isOwnersRepresentative()">
                                <b-dropdown-item to="/user/list">Users</b-dropdown-item>
                            </template>
                            <b-dropdown-item to="/invitations">Sent Invitations</b-dropdown-item>
                            <b-dropdown-item to="/messages">Messages</b-dropdown-item>
                            <b-dropdown-item to="/notifications">My Notifications</b-dropdown-item>

                            <template v-if="$user.isAdmin() || $user.isSuperAdmin()">
                                <b-dropdown-item to="/notifications/admin">System-wide Notifications</b-dropdown-item>
                                <b-dropdown-item to="/group-email">Group Email</b-dropdown-item>
                                <b-dropdown-item disabled>Config</b-dropdown-item>
                                <b-dropdown-item to="/help/list">Help Messages</b-dropdown-item>
                                <b-dropdown-item to="/intro/list">Intro Paragraphs</b-dropdown-item>
                                <b-dropdown-item to="/userlog/list">User Log Records</b-dropdown-item>
                            </template>
                            <template v-if="$user.isAdmin() || $user.isSuperAdmin()">
                                <b-dropdown-item to="/site/system">System Status</b-dropdown-item>
                            </template>

                            <b-dropdown-item disabled>Invitations:</b-dropdown-item>
                            <template v-if="$user.isAdmin() || $user.isSuperAdmin()">
                                <b-dropdown-item to="/programadmin/invite">Program Admin</b-dropdown-item>
                            </template>
                            <template v-if="$user.isAdmin() || $user.isSuperAdmin() || $user.isProgramAdmin()">
                                <b-dropdown-item to="/projectmanager/invite">Project Manager</b-dropdown-item>
                                <b-dropdown-item to="/ownersrepresentative/invite">Owner's Representative</b-dropdown-item>
                                <b-dropdown-item to="/auditor/invite">Auditor</b-dropdown-item>
                            </template>
                            <b-dropdown-item to="/equipmentowner/invite">Equipment Owner</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </div>
                    <!--</b-navbar-nav>-->
                    <!-- Right aligned nav items -->
                    <!--<b-navbar-nav class="ml-auto">-->

                    <!-- guest menu -->
                    <div class="main-menu__right menu-group">
                        <!--<b-nav-item to="/" v-if="!$user.userId()">
                            Home
                        </b-nav-item>-->

                        <!-- simple profile link (for participants) -->
                        <b-nav-item v-if="isApproved"
                                    :to="{name:'profileView'}"
                                    class="main-menu__logged-in-as">
                            {{ $user.email() }}
                        </b-nav-item>

                        <b-nav-item v-if="$user.userId()"
                                    @click="logout()">
                            Log out
                        </b-nav-item>

                        <b-nav-item v-if="$user.isMasking()"
                                    @click="unmask()">
                            Unmask
                        </b-nav-item>
                    </div>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

    </div>
</template>
<script>
import Vue from 'vue'
import User from '@/User'
import Authorization from '@/providers/Authorization'

/**
 * Displays the top menu with user presence and various commands appropriate to the user's role
 */
export default Vue.extend({
    name: 'UserMenu',
    data () {
        return {
            canListCompanies: false,
        }
    },
    methods: {
        logout () {
            User.logoutUser(this)
        },
        unmask () {
            User.unmaskUser(this)
        }
    },
    computed: {
        isApproved () {
            return this.$user.userId() && this.$store.state.currentUser.approved
        },
    },
    created () {
        if (this.$user.userId()) {
            Authorization.can({ action: 'list', model: 'company' }).then((can) => {
                this.canListCompanies = can
            })
        }
    }
})
</script>

<style lang="scss">
@import '../../sass/variables_mixins';

.user-menu {
    height: 100%;

    > .navbar {
        padding: 0;
        height: 100%;
        z-index: 4;
    }
}

@media (min-width:992px) {
    .user-menu > .navbar {
        position: absolute;
        top:0;
        right:20px;
        width:100%;
    }

    .navbar-brand {
        position: relative;
        z-index: 5;
    }
}

.navbar-collapse .navbar-nav a.nav-link {
    color: var(--black);
}

.main-menu {
    height: 70px;

    > .navbar {
        height: 70px;
    }

    .main-menu__center .nav-link {
        font-weight: bold;
    }

    @media (min-width: 992px) {
        width: 100%;
        justify-content: flex-end;
        .menu-group {
            display: flex;
            align-items: center;
        }

        .show .dropdown-toggle:after {
            display: inline-block!important;
            margin-left: 0.255em;
            vertical-align: 0.255em;
            content: "";
            border-top: 0.3em solid #fff;
            border-right: 0.3em solid transparent;
            border-bottom: 0;
            border-left: 0.3em solid transparent;
        }

        .main-menu__center {
            width: 50%;
            justify-content: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            > li > .nav-link {
                padding-left: 12px;
                padding-right: 12px;
            }
        }

        .main-menu__right {
            width: 500px;
            justify-content: flex-end;
        }

        > .navbar {
            padding-left: 0;
            padding-right: 0;
        }
        &.navbar-nav {
            .nav-item {
                &:first-child a.nav-link {
                    padding-left: 0;
                }

                a.nav-link {
                    padding-left: 1.25em;
                    padding-right: 1.25em;
                    font-size: 14px;
                    color: var(--main-menu-item-desktop);
                    @include transition(all .3s);

                    &:hover, &:focus {
                        color: var(--light-blue-darken-20) !important;
                    }

                    &:focus-visible {
                        outline-color: var(--light-blue);
                    }

                }

                &.show .dropdown-toggle span {
                    color: #fff !important;
                }
            }
        }
    }

    @media (min-width: 1440px) {
        &.navbar-nav .main-menu__center .nav-item a.nav-link {
            font-size: 18px;
        }

    }

}

.main-menu__center .dropdown-item.disabled, .dropdown-item:disabled {
    color: #000;
    font-weight: bold;
    font-size: 18px;
    padding-top: 10px;
}

.main-menu__environment {
    position: fixed;
    top: -2px;
    left: 50%;
    transform: translateX(-50%);
    padding: .25em 1em;
    background-color: #ccc;
    z-index: 30;
}

.main-menu__logged-in-as {
}

@media (max-width: 1023px) {
    .navbar-expand-md .navbar-toggler {
        display: block;
    }
}

.content ul.navbar-nav {
    margin-left: 0;
}

@media (min-width: 576px) {
    .dashboard-buttons a {
        padding-left: 1rem;
        padding-right: 1rem;
    }
}

@media (min-width: 768px) {
    .navbar-light .navbar-nav .show > a,
    .navbar-light .navbar-nav .active > a,
    .navbar-light .navbar-nav a.show,
    .navbar-light .navbar-nav a.active {
        color: #fff;
        background-color: var(--accent-color);
        cursor: default;

        &:after {
            display: none;
        }
    }
}

.navbar-toggler {
    border: none;
    @include vertical-center;
    padding: 0;
    right: 0;

    .navbar-toggler-icon {
        background-size: 100% auto;
    }
}

@media (max-width: 991px) {

    .user-menu {
        display:flex;
        justify-content: space-between;
    }
    .user-menu > .navbar {
        width:40px;
    }
    .has-breadcrumbs .user-menu > .navbar {
        //width:50%;
        //float:right;
    }

    .main-menu {
        &.navbar-nav .nav-link:focus, &.navbar-nav .show a.nav-link {
            color:var(--black)!important;
        }
        .dropdown-menu {
            background-color: var(--light-blue);
            border-radius: 0;
            border: none;
        }
    }

    .main-menu__center {
        padding:.75em 0;
        border-bottom: solid 1px rgba(255, 255, 255, .3);
        .nav-link {
            font-size: 21px;
        }
    }

    .main-menu__right {
        padding-top: 1em;
    }
    .navbar-collapse {
        //display:block!important;
        .navbar-nav {
            position: fixed;
            z-index: 100;
            left: 0;
            top: 0;
            height: 100%;
            width: 300px;
            display: block;
            background-color: var(--black);
            transform: translateX(-100%);
            margin: 0;
            transition: transform .3s;

            a.nav-link {
                display: block;
                color: #fff !important;
                padding: .75em 1em;
            }
        }

        &.show > .navbar-nav {
            transform: translateX(0);
        }
    }

    .navbar-light .navbar-nav .show > .nav-link, .navbar-light .navbar-nav .active > .nav-link, .navbar-light .navbar-nav .nav-link.show, .navbar-light .navbar-nav .nav-link.active {
        color: #fff;
        background-color: var(--accent-color);
    }

    .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
        color: #fff;
        background-color: var(--accent-color);
    }
}
</style>
